/** @format */

import ReactDOM from "react-dom/client";
import App from "./App";
import { MapProvider } from "./context/MapContext";
import { LanguagueProvider } from "./context/LanguageContext";

ReactDOM.createRoot(document.getElementById("root")).render(
  <LanguagueProvider>
    <MapProvider>
      <App />
    </MapProvider>
  </LanguagueProvider>
);
